import { useSelector, useDispatch } from 'react-redux'
import { setAdmin, initialState } from 'store/auth/userSlice'
import {apiSignIn, apiSignInWithDigital} from 'services/AuthService'
import { onSignInSuccessAdmin, onSignOutSuccessAdmin } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { accessToken, refreshToken, signedIn } = useSelector((state) => state.auth.session)
    const { role } = useSelector((state) => state.auth.user)

    const signIn = async (values) => {
        try {
			const resp = await apiSignIn(values)
			if (resp.data.user) {
				const { session, user } = resp.data
				dispatch(onSignInSuccessAdmin(session))
				if(user) {
					dispatch(setAdmin(user || {
						first_name: 'Anonymous',
						last_name: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: 'Giriş edildi'
                }
			}
			throw resp.data
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.message || errors.toString(),
				data: errors?.data || {}
            }
		}
    }

    const signInWithDigital = async (values) => {
		console.log('testtttt')
        try {
			const resp = await apiSignInWithDigital(values)
			if (resp.data.user) {
				const { session, user } = resp.data
				dispatch(onSignInSuccessAdmin(session))
				if(user) {
					dispatch(setAdmin(user || {
						first_name: 'Anonymous',
						last_name: 'Anonymous',
						authority: ['USER'],
						email: ''
					}))
				}
                return {
                    status: 'success',
                    message: 'Giriş edildi'
                }
			}
			throw resp.data
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.message || errors.toString(),
				data: errors?.data || {}
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccessAdmin())
		dispatch(setAdmin(initialState))
		localStorage.workSpacesSelected = JSON.stringify({})
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut = async () => {
		handleSignOut()
	}

    return {
        authenticated: accessToken && signedIn,
        role: role,
		accessToken,
		refreshToken,
        signIn,
        signOut,
		signInWithDigital
    }
}

export default useAuth
